import React, { useState, useContext } from 'react'
import { components } from 'cng-web-lib'
import {
    Box,
    Grid,
    InputAdornment,
    makeStyles,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Typography
} from '@material-ui/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { A6ATranslationContext } from './contexts/A6ATranslationContext'
import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
    table: {
        '& .MuiTableHead-root': {
            backgroundColor: theme.palette.background.sectionOddBg,
            '& .MuiTableCell-head': {
                borderBottom: 0,
                fontSize: 12,
                fontWeight: 700,
                lineHeight: 1.2,
                textTransform: 'uppercase'
            }
        },
        '& .MuiTableBody-root': {
            '& .MuiTableRow-root': {
                '&:last-child': {
                    '& .MuiTableCell-root': {
                        borderBottom: 0
                    }
                }
            }
        },
        '& .MuiTableCell-root': {
            padding: '8px 16px'
        }
    }
}))

const { button: { CngButton, CngIconButton } } = components

function TaciOcnA6aShipmentsTable(props) {
    const { data, onAddShipment, onEditShipment, onDeleteShipment } = props
    const { getTranslatedText } = useContext(A6ATranslationContext)

    const classes = useStyles()

    const [searchTerm, setSearchTerm] = useState('')

    const filtered = searchTerm !== '' ?
        data.filter((shipment) =>
            shipment.itemDesc1.toLowerCase().includes(searchTerm.toLowerCase())
        ) : data

    return (
        <>
            <Box mb={2}>
                <Grid container spacing={2}>
                    <Grid item xs>
                        {data.length > 0 && (
                            <TextField
                                fullWidth
                                onChange={(event) => setSearchTerm(event.target.value)}
                                placeholder='Search in your entries'
                                size='small'
                                variant='outlined'
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position='start'>
                                            <FontAwesomeIcon icon={['fal', 'search']} />
                                        </InputAdornment>
                                    )
                                }}
                            />
                        )}
                    </Grid>

                    {onAddShipment && (
                        <Grid item xs='auto'>
                            <CngButton color='secondary' onClick={onAddShipment} size='medium'
                                startIcon={<FontAwesomeIcon icon={['fal', 'plus-circle']} />}>
                                Add Shipment
                            </CngButton>
                        </Grid>
                    )}
                </Grid>
            </Box>

            <TableContainer>
                <Table className={clsx(classes.table, 'new-ui-table-component__table')}>
                    <TableHead>
                        <TableRow>
                            <TableCell>{getTranslatedText('A6A', 'itemDesc1')}</TableCell>
                            <TableCell>{getTranslatedText('A6A', 'containerNo')}</TableCell>
                            {(onEditShipment || onDeleteShipment) && (<TableCell align='right'>Action</TableCell>)}
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {filtered.length > 0 ? (
                            filtered.map((shipment, index) => (
                                <TableRow key={shipment._id || shipment.id || index}>
                                    <TableCell>{shipment.itemDesc1}</TableCell>
                                    <TableCell>{shipment.containerNo}</TableCell>
                                    {(onEditShipment || onDeleteShipment) && (
                                        <TableCell>
                                            <Box display='flex' flexDirection='row' justifyContent='flex-end' style={{ gap: 8 }}>
                                                {onEditShipment && (
                                                    <CngIconButton type='outlined' icon={['fal', 'pen']} onClick={() => onEditShipment(shipment)} size='small' />
                                                )}
                                                {onDeleteShipment && (
                                                    <CngIconButton type='outlined' icon={['fal', 'trash']} onClick={() => onDeleteShipment(shipment)} size='small' />
                                                )}
                                            </Box>
                                        </TableCell>
                                    )}
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <TableCell align='center' colSpan={2 + (onEditShipment || onDeleteShipment ? 1 : 0)}>
                                    <Typography variant='body2' color='textSecondary'>
                                        No records to display
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    )
}

export default TaciOcnA6aShipmentsTable
